import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { paymentShareMembersSpentAmountBackend } from './payment-share-members-spent-amount.backend';
import { paymentShareMembersSpentAmountReducer } from './payment-share-members-spent-amount.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'paymentShareMembersSpentAmount',
      paymentShareMembersSpentAmountReducer,
    ),
    BackendModule.forFeature(
      'paymentShareMembersSpentAmount',
      paymentShareMembersSpentAmountBackend,
    ),
  ],
})
export class DatastorePaymentShareMembersSpentAmountModule {}
